<template>
  <div class="talent-level-container">
    <div class="list-wrap">
      <div class="tile is-parent">
        <article class="tile is-child box flex-3">
          <div class="search-wrap">
            <label class="label">筛选内容</label>
            <div class="block">
              <label class="label inline-block">状态</label>
              <label class="inline-block">
                <input type="checkbox" value="1" v-model="search.status">已放行
              </label>
              <label class="inline-block wait-verify">
                <input type="checkbox" value="0" v-model="search.status">待放行
                <span v-if="statusCount && statusCount[0]" class="num-icon">{{statusCount[0]}}</span>
              </label>
              <label class="inline-block">
                <input type="checkbox" value="2" v-model="search.status">不合适
              </label>
              <label class="inline-block">
                <input type="checkbox" value="3" v-model="search.status">回收站
              </label>
            </div>

            <div class="control">
              <label class="label inline-block r-top">类型</label>
              <span class="select">
                <select v-model="search.articleType">
                  <option value="-1">全部</option>
                  <option :value="opt.type" v-for="opt in allOpts.articleTypes">{{opt.name}}</option>
                </select>
              </span>
            </div>
            <div class="control">
              <label class="label inline-block r-top">关键词</label>
              <input type="text" class="input width-2" v-model="search.keyword">
            </div>
            <div class="control">
              <label class="label inline-block r-top">动态ID</label>
              <input type="text" class="input width-2" v-model="search.articleId">
            </div>
            <div class="control"  v-if="!isTopicSearch">
              <label class="label inline-block r-top">bloggerId</label>
              <input type="text" class="input width-2" v-model="search.bloggerId">
            </div>
            <div class="control"  v-if="!isTopicSearch">
              <label class="label inline-block r-top">feedId</label>
              <input type="text" class="input width-2" v-model="search.feedId">
            </div>
            <div class="control">
              <label class="label inline-block r-top">运营标签</label>
              <span class="inline-block width-4">
                <el-select v-model="search.operationTags" multiple filterable placeholder="请选择">
                    <el-option
                      v-for="item in allOpts.operationTags"
                      :key="item.tagId"
                      :label="item.name"
                      :value="item.tagId">
                    </el-option>
                </el-select>
              </span>
            </div>
            <div class="control">
              <label class="label inline-block r-top">属性标签</label>
              <span class="inline-block width-4">
                <el-select v-model="search.propertiesTags" multiple filterable placeholder="请选择">
                    <el-option
                      v-for="item in allOpts.propertiesTags"
                      :key="item.tagId"
                      :label="item.name"
                      :value="item.tagId">
                    </el-option>
                </el-select>
              </span>
            </div>
            <div class="control">
              <label class="label inline-block r-top">放行时间</label>
              <span class="inline-block">
                <el-date-picker
                  v-model="searchProp.verifyStartTime"
                  type="datetime"
                  placeholder="放行开始时间"
                  align="right">
                </el-date-picker>
                <span class="r-top">~</span>
                <el-date-picker
                  v-model="searchProp.verifyEndTime"
                  type="datetime"
                  placeholder="放行结束时间"
                  align="right">
                </el-date-picker>
              </span>
            </div>
            <div class="control">
              <label class="label inline-block r-top">来源发帖时间</label>
              <el-date-picker
                v-model="searchProp.publishStartTime"
                type="datetime"
                placeholder="开始时间"
                align="right">
              </el-date-picker>
              <span class="r-top">~</span>
              <el-date-picker
                v-model="searchProp.publishEndTime"
                type="datetime"
                placeholder="结束时间"
                align="right">
              </el-date-picker>
            </div>
            <div class="control">
              <label class="label inline-block r-top">ICON</label>
              <span class="inline-block width-4">
                <el-select v-model="search.bloggerId" filterable placeholder="请选择">
                    <el-option
                      v-for="item in allOpts.bloggers"
                      :key="item.bloggerId"
                      :label="item.name"
                      :value="item.bloggerId">
                    </el-option>
                </el-select>
              </span>
            </div>
            <div class="control"  v-if="!isTopicSearch">
              <label class="label inline-block r-top">频道选择</label>
              <span class="inline-block width-4">
                <el-select v-model="search.channelId" filterable placeholder="请选择">
                    <el-option
                      v-for="item in allOpts.channels"
                      :key="item.channelId"
                      :label="item.name"
                      :value="item.channelId">
                    </el-option>
                </el-select>
              </span>
            </div>
            <!--<div class="control"  v-if="!isTopicSearch">
              <label class="label inline-block r-top">专题</label>
              <span class="inline-block width-4">
                <el-select v-model="search.topicId" filterable placeholder="请选择">
                    <el-option
                      v-for="item in allOpts.topics"
                      :key="item.topicId"
                      :label="item.name"
                      :value="item.topicId">
                    </el-option>
                </el-select>
              </span>
            </div>-->
            <div class="control" v-if="!isTopicSearch">
              <label class="label inline-block r-top">图片分数：</label>
              <span class="select">
                <select v-model="search.compare">
                  <option value="0">大于等于</option>
                  <option value="1">小于</option>
                </select>
              </span>
              <input type="number" class="input width-1" v-model="search.score">
            </div>
            <div class="control">
              <button class="button is-info" @click="doSearch">搜索</button>
            </div>
          </div>
        </article>
        <div class="flex-space"></div>
        <article class="tile is-child box flex-1" >
          <label class="label">数据</label>
          <div class="data-wrap">
            <div class="data-item">
              <label class="label">本日已抓取</label>
              <label class="label">{{todayData.catched}}</label>
            </div>
            <div class="data-item">
              <label class="label">本日已放行</label>
              <label class="label">{{todayData.verified}}</label>
            </div>
            <div class="data-item">
              <label class="label">总抓取内容</label>
              <label class="label">{{todayData.totalCatched}}</label>
            </div>
            <div class="data-item">
              <label class="label">总已放行</label>
              <label class="label">{{todayData.totalVerified}}</label>
            </div>
            <div class="data-item">
              <label class="label">待放行</label>
              <label class="label">{{todayData.waitVerified}}</label>
            </div>
            <div class="data-item">
              <label class="label">超过12小时未放行</label>
              <label class="label">{{todayData.over12h}}</label>
            </div>
            <div class="data-item">
              <label class="label">本日抓取商品数</label>
              <label class="label">{{todayData.todayGoodsCatched}}</label>
            </div>
            <div class="data-item">
              <label class="label">本日已上架商品数</label>
              <label class="label">{{todayData.todayGoodsOnline}}</label>
            </div>
            <div class="data-item">
              <label class="label">总抓取商品数</label>
              <label class="label">{{todayData.goodsCatched}}</label>
            </div>
            <div class="data-item">
              <label class="label">总上架商品数</label>
              <label class="label">{{todayData.goodsOnline}}</label>
            </div>
          </div>
        </article>
      </div>
      <div class="clearfix">
        <router-link class="button is-success" style="margin-left: 10px;" :to="{name:'articleEdit',query:{articleType:'0'}}">新增图集</router-link>
        <router-link class="button is-info" :to="{name:'articleEdit',query:{articleType:'1'}}">新增文章</router-link>
        <el-pagination
          v-if="count > 0"
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent js_handle" style="height:80px;">
        <article class="tile is-child box set-container" :class="{'fixed':isFixed}">
          <div>
            <label class="label inline-block">圈选图片：</label>
            <el-switch
              v-model="rules.imageStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              @change="changeAutoVerifyStatus(rules.imageStatus,1)">
            </el-switch>
            <span class="inline-block blue width-2" :class="{'hide':!rules.imageStatus}">已圈选 {{articleTotalImgCount}} 张图片</span>
            <button class="button is-danger" @click="onBatchDeleteImg">批量删除图片</button>
            <button class="button is-success" @click="onBatchVerify">批量放行</button>
          </div>
          <div>
            <span class="switch-bar">
              <label class="label inline-block">自动放行：</label>
              <el-switch
                v-model="rules.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeAutoVerifyStatus(rules.status,0)">
              </el-switch>
               <!--<span class="red">{{isPermit | getPermit}}</span>-->
            </span>
            <button class="button r-top" @click="onShowRulesModal">图片分数设置</button>
            <label class="label inline-block"><input type="checkbox" class="checkbox" v-model="searchProp.orderByTime">按发帖时间正序</label>
          </div>
        </article>
      </div>
      <div class="article-list" v-if="count > 0">
        <article-card ref="articleCard"
                      :source="list"
                      :all-operation-tag="allOpts.operationTags"
                      :search-status="search.status"
                      :search-params="search"
                      :rules="rules"
                      :is-topic-search="isTopicSearch"
                      @update-article-list="UPDATE_ARTICLE_LIST"
                      @update-operations-tag-event="UPDATE_OPERATIONSTAG_EVENT">
        </article-card>
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="图片分数设置" :visible.sync="modal.visible" size="tiny" :lock-scroll="false">
      <div>
        <div class="block">
          <label class="label">自动放行设置：</label>
          <div class="margin-left">
            <span class="label inline-block r-top">动态图片平均分大于等于</span>
            <input type="number" class="input" style="width:80px;" v-model="modal.rules.score">
            <span class="label inline-block r-top">分，自动放行通过</span>
          </div>
        </div>
        <div class="block">
          <label class="label">红框圈选设置：</label>
          <div class="margin-left">
            <span class="label inline-block r-top">单张图片的分数小于</span>
            <input type="number" class="input" style="width:80px;" v-model="modal.rules.imageScore">
            <span class="label inline-block r-top">分</span>
            <label class="label">注：已圈选的图片，点击左上角的分数，可取消红框圈选</label>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modal.visible = false;">取 消</el-button>
        <el-button type="primary" @click="changeRules">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
  import ArticleCard from './articleCard.vue';
  import {throttle} from 'UTILS/tools'
  import {getTimeByDateStr} from 'UTILS/date'
  import {mapState,mapActions} from 'vuex'

  export default {
    components:{
      ArticleCard,
    },
    computed:{
      ...mapState({
        articleTotalImgCount:state => state.articleTotalImgCount
      }),
    },
    data(){
      return {
        search:{
          bloggerId: '',
          feedId:'',
          status:["0"],
          articleType:'-1',
          keyword:'',
          articleId:'',
          operationTags:[],
          propertiesTags:[],
          verifyTime:'',
          publishTime:'',
          orderByTime:0,
          channelId:'',
          topicId:'',
          compare:'0',
          score:'',
          page:1,
          pageSize:50,
          selectedBlogger:{},
          selectedChannel:{},
          selectedOperationTags:[],
          selectedPropertiesTags:[],
          selectedTopic:{},
        },
        searchProp:{
          verifyStartTime:'',
          verifyEndTime:'',
          publishStartTime:'',
          publishEndTime:'',
          orderByTime:false
        },
        allOpts:{
          operationTags:[],
          propertiesTags:[],
          articleTypes:[],
          bloggers:[],
          channels:[],
          topics:[]
        },
        rules:{
          status:0,
          score:0,
          imageStatus:0,
          imageScore:0
        },
        list:[],
        count:0,
        todayData:{},
        statusCount:{},
        modal:{
          visible:false,
          rules:{
            score:0,
            imageScore:0
          }
        },
        scrollTop:0,
        handlePos:0,
        scrollHandle:null,
        isFixed:false,
        isTopicSearch:false
      }
    },
    watch:{
      "searchProp.orderByTime"(){
        this.getList();
      }
    },
    mounted(){
      if(this.$route.query.searchParams){
        this.search = Object.assign(this.search,JSON.parse(this.$route.query.searchParams));
        if(this.search.verifyTime){
          this.searchProp.verifyStartTime = this.search.verifyTime.split("~")[0]
          this.searchProp.verifyEndTime = this.search.verifyTime.split("~")[1]
        }
        if(this.search.publishTime){
          this.searchProp.publishStartTime = this.search.publishTime.split("~")[0]
          this.searchProp.publishEndTime = this.search.publishTime.split("~")[1]
        }
        if(this.search.orderByTime === 1){
          this.searchProp.orderByTime = true
        }else{
          this.searchProp.orderByTime = false
        }
      }
      if(this.$route.query.bloggerId){
        this.search.bloggerId = this.$route.query.bloggerId
      }
      if(this.$route.query.topicId){
        this.search.topicId = this.$route.query.topicId
        this.search.status = []
      }
      if(this.$route.query.articleId){
        this.search.articleId = this.$route.query.articleId
        this.search.status = []
      }
      if(parseInt(this.$route.query.type)===1){
        this.search.propertiesTags = [parseInt(this.$route.query.tagId)]
        this.search.status = []
      }
      if(parseInt(this.$route.query.type)===0){
        this.search.operationTags = [parseInt(this.$route.query.tagId)]
        this.search.status = []
      }
      if(this.$route.query.status){
        this.search.status = [this.$route.query.status]
      }
      this.scrollTop = this.$route.query.scrollTop ? this.$route.query.scrollTop : 0;
        this.getList();
        this.getAllOptions();
        this.listenScroll()
    },
    methods:{
      ...mapActions([
        'updateArticleImgCount',
      ]),
      getList(){
        this.initSearchParams();
        let _url=null;
        if(this.search.topicId){
          this.isTopicSearch = true;
          _url="/admin.php?method=blogger.getTopicArticleList"
        }else {
          this.isTopicSearch = false;
          _url="/admin.php?method=blogger.getArticleList"
        }
        HttpRequest.get(_url,this.search).then(response => {
          this.count = 0; //该出为触发瀑布流渲染的hack处理
          setTimeout(()=>{
            this.rules = response.data.rules;
            this.list = _.toArray(response.data.list);
            this.todayData = response.data.todayData;
            this.statusCount = response.data.statusCount;
            this.count = response.data.count;
            this.updateArticleImgCount(0)
            _.each(response.data.list,item => {
              item.checked = false
              item.images = _.toArray(item.images)
              _.each(item.images, imgItem => {
                if(typeof imgItem.score !== 'undefined' && imgItem.score < this.rules.imageScore){
                  imgItem.checked = true
                  this.updateArticleImgCount(1)
                }else {
                  imgItem.checked = false
                }
              })
            })
            setTimeout(()=>{
              this.scrollTop && window.scrollTo(0,this.scrollTop);
            },1000)
          },0)
        })
      },
      handleCurrentChange(page){
        if(this.search.page !== page){
          this.search.page = page;
          this.clearRouteQuery();
          this.getList();
        }
      },
      initSearchParams(){
        if(this.searchProp.verifyStartTime || this.searchProp.verifyEndTime){
          this.search.verifyTime = getTimeByDateStr(this.searchProp.verifyStartTime) + "~" + getTimeByDateStr(this.searchProp.verifyEndTime);
        }else {
          this.search.verifyTime = ""
        }
        if(this.searchProp.publishStartTime || this.searchProp.publishEndTime){
          this.search.publishTime = getTimeByDateStr(this.searchProp.publishStartTime) + "~" + getTimeByDateStr(this.searchProp.publishEndTime)
        }else {
          this.search.publishTime = ""
        }
        if(this.searchProp.orderByTime){
          this.search.orderByTime = 1;
        }else {
          this.search.orderByTime = 0;
        }
      },
      doSearch(){
        this.search.page = 1;
        this.getList();
        this.clearRouteQuery();
      },
      clearRouteQuery(){
        this.scrollTop = 0
        if(this.$route.query.bloggerId){
          this.$router.push({
            name:'articleList',
            query:{
              bloggerId:this.$route.query.bloggerId
            }
          })
        }else {
          this.$router.push({name:'articleList'})
        }
      },
      getAllOptions(){
        HttpRequest.get('/admin.php?method=blogger.getTags').then(response => {
          this.allOpts.operationTags = _.toArray(response.data.operationTags);
          this.allOpts.propertiesTags = _.toArray(response.data.propertiesTags);
          this.allOpts.articleTypes = _.toArray(response.data.articleTypes);
          this.allOpts.channels = _.toArray(response.data.channels);
          this.allOpts.channels.unshift({
            channelId:-1,
            name:'全部'
          })
        })
        HttpRequest.get('/admin.php?method=fashion.getBloggers').then(response => {
          this.allOpts.bloggers = _.toArray(response.data);
          this.allOpts.bloggers.unshift({
            bloggerId:'',
            name:"全部"
          })
        })
        HttpRequest.get('/admin.php?method=fashion.getInitTopicList').then(response => {
          this.allOpts.topics = _.toArray(response.data.list)
          this.allOpts.topics.unshift({
            topicId:'',
            name:"全部"
          })
        })
      },
      onShowRulesModal(){
        this.modal.rules.status = this.rules.status
        this.modal.rules.score = this.rules.score
        this.modal.rules.imageScore = this.rules.imageScore
        this.modal.visible = true
      },
      updateOperationTags(obj){
        if(!obj){
          this.search.operationTags = [];
          return false;
        }
        let tagIds = [];
        _.each(obj,item => {
          tagIds.push(item.tagId)
        })
        this.search.operationTags = tagIds;
        this.search.selectedOperationTags = obj;
      },
      updatePropertiesTags(obj){
        if(!obj){
          this.search.propertiesTags = [];
          return false;
        }
        let tagIds = [];
        _.each(obj,item => {
          tagIds.push(item.tagId)
        })
        this.search.propertiesTags = tagIds;
        this.search.selectedPropertiesTags = obj;
      },
      updateBloggers(obj){
        if(!obj){
          this.search.bloggerId = "";
          return false;
        }
        this.search.bloggerId = obj.bloggerId;
        this.search.selectedBlogger = obj;
      },
      updateChannel(obj){
        if(!obj){
          this.search.channelId = "";
          return false;
        }
        this.search.channelId = obj.channelId
        this.search.selectedChannel = obj;
      },
      updateTopic(obj){
        if(!obj){
          this.search.topicId = "";
          return false
        }
        this.search.topicId = obj.topicId
        this.search.selectedTopic = obj
      },
      /**
       * 设置图片放行规则
       * @returns {boolean}
       */
      changeRules(){
        if(this.modal.rules.score <= 0 || this.modal.rules.imageScore <= 0){
          this.$message("分数不能为空且必须大于0！")
          this.modal.rules.score = this.rules.score
          this.modal.rules.imageScore = this.rules.imageScore
          return false
        }
        let params = {
          status : this.rules.status,
          score : this.modal.rules.score,
          imageStatus: this.rules.imageStatus,
          imageScore: this.modal.rules.imageScore
        }
        HttpRequest.post('/admin.php?method=fashion.doSaveRules',params).then(response => {
          if(response.data.success){
            this.$message("设置成功")
            this.rules.score = this.modal.rules.score
            this.rules.imageScore = this.modal.rules.imageScore
            this.modal.visible = false
            this.$refs.articleCard.checkImgByImgScore()
          }
        })
      },
      /**
       * 设置自动放行/图片圈选状态  0：自动放行  1：圈选
       */
      changeAutoVerifyStatus(status,type){
        status = status ? 1 : 0
        let params = {}
        if(type === 0){
          params = {
            status : status,
            score : this.rules.score,
            imageStatus: this.rules.imageStatus,
            imageScore: this.rules.imageScore
          }
        }else if(type === 1){
          params = {
            status: this.rules.status,
            score : this.rules.score,
            imageStatus: status,
            imageScore: this.rules.imageScore
          }
        }
        HttpRequest.post('/admin.php?method=fashion.doSaveRules',params).then(response => {
          if(response.data.success){
            this.$message("设置成功!")
            if(type === 0){
              this.rules.status = status
            }else if(type === 1){
              this.rules.imageStatus = status
            }
          }
        })
      },
      onBatchVerify(){
        this.$refs.articleCard.onShowBatchVerifyModal()
      },
      onBatchDeleteImg(){
        this.$refs.articleCard.onShowDeleteImgModal()
      },
      listenScroll(){
        this.handlePos = $('.js_handle') && $('.js_handle').offset(),

        this.scrollHandler = throttle(this.scrollEvent,500,1000)
        $(document).on("scroll",this.scrollHandler)
      },
      scrollEvent(){
        let scrollTop = $(document).scrollTop()
        if(scrollTop > this.handlePos.top){
          this.isFixed = true
        }else {
          this.isFixed = false
        }
      },
      UPDATE_ARTICLE_LIST(scrollTop){
        setTimeout(()=>{
          this.scrollTop = scrollTop
          this.getList();
        },1000)
      },
      UPDATE_OPERATIONSTAG_EVENT(){
        setTimeout(()=>{
          this.getAllOptions()
        },2000)
      },
    },
    destroyed(){
      $(document).off("scroll",this.scrollHandler)
    },
    filters:{
      getPermit(status){
        if(status){
          return "开启中"
        }else{
          return "关闭中"
        }
      }
    }
  }
</script>
<style lang="less">
  .list-wrap {
    .is-parent {
      .flex-1 {
        flex-grow: 1;
      }
      .flex-3 {
        flex-grow: 3;
      }
      .flex-space {
        flex-basis: 20px;
      }
      .is-child {
        .search-wrap {
          .block {
            label {
              margin-left: 10px;
            }
          }
          .num-icon {
            display: inline-block;
            padding: 0 3px;
            height:15px;
            background-color: #ed6c63;
            color:#fff;
            border-radius: 15px;
            font-size: 12px;
            text-align: center;
            line-height: 15px;
          }
        }
        .data-wrap {
          display: flex;
          flex-wrap: wrap;
          width: 400px;
          .data-item {
            width:50%;
            margin-top: 20px;
          }
        }
      }
      .set-container {
        display: flex;
        justify-content: space-between;
        .switch-bar {
          display: inline-block;
          margin-top: 5px;
          margin-left: 10px;
        }
      }
    }
    .article-list {
      margin-left: 10px;
    }
    .hide {
      visibility: hidden;
    }
    .fixed {
      position: fixed;
      top:53px;
      left:220px;
      z-index: 1025;
    }
  }
</style>
